var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarIcon = function SvgCalendarIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.333,
    height: 25.333,
    viewBox: "0 0 25.333 25.333",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.365,1.979H21.177V0H19.2V1.979H6.135V0H4.156V1.979H2.969A2.972,2.972,0,0,0,0,4.948V22.365a2.972,2.972,0,0,0,2.969,2.969h19.4a2.972,2.972,0,0,0,2.969-2.969V4.948A2.972,2.972,0,0,0,22.365,1.979Zm.99,20.385a.991.991,0,0,1-.99.99H2.969a.991.991,0,0,1-.99-.99V9.3H23.354Zm0-15.042H1.979V4.948a.991.991,0,0,1,.99-.99H4.156V5.937H6.135V3.958H19.2V5.937h1.979V3.958h1.187a.991.991,0,0,1,.99.99Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.931 11.793)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.069 0.207)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.862 11.793)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.138 0.207)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.793 11.793)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.207 0.207)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.724 11.793)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.276 0.207)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.655 11.793)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.345 0.207)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.931 15.724)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.069 0.276)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.862 15.724)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.138 0.276)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.793 15.724)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.207 0.276)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.724 15.724)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.276 0.276)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.931 19.655)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.069 0.345)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.862 19.655)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.138 0.345)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.793 19.655)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.207 0.345)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.724 19.655)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.276 0.345)"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.655 15.724)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(0.345 0.276)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarIcon, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };